"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var seesignage_utils_1 = require("@seesignage/seesignage-utils");
var nanoid_1 = require("nanoid");
var MediaCarouselVideo_1 = __importDefault(require("./MediaCarouselVideo"));
var MediaCarouselImage_1 = __importDefault(require("./MediaCarouselImage"));
var MediaCarouselMediaMissing_1 = __importDefault(require("./MediaCarouselMediaMissing"));
var MediaCarouselContent_1 = __importDefault(require("./MediaCarouselContent"));
var getNextVisiblePlaylistItemIndex = function (carouselItems, currentIndex) {
    var nextVisibleItemIndex;
    var startFromIndex = currentIndex === undefined ? 0 : currentIndex + 1;
    // Case 1: find next item after current index
    for (var index = startFromIndex; index < carouselItems.length; index++) {
        var isItemVisible = (0, seesignage_utils_1.isPlaylistItemVisibleByConditions)({
            item: carouselItems[index],
            allItems: carouselItems,
            screenHasChannels: false,
            currentWeather: undefined,
            currentTimeMs: Date.now()
        });
        if (isItemVisible) {
            nextVisibleItemIndex = index;
            break;
        }
    }
    if (typeof nextVisibleItemIndex === 'number') {
        return nextVisibleItemIndex;
    }
    // Case 2: no next item found after current index, start again from the beginning
    for (var index = 0; index < carouselItems.length; index++) {
        var isItemVisible = (0, seesignage_utils_1.isPlaylistItemVisibleByConditions)({
            item: carouselItems[index],
            allItems: carouselItems,
            screenHasChannels: false,
            currentWeather: undefined,
            currentTimeMs: Date.now()
        });
        if (isItemVisible) {
            nextVisibleItemIndex = index;
            break;
        }
    }
    return nextVisibleItemIndex;
};
var MediaCarouselComponent = function (_a) {
    var mediaCarouselProps = _a.mediaCarouselProps, editable = _a.editable, width = _a.width, height = _a.height;
    var carouselItems = mediaCarouselProps.carouselItems, objectFit = mediaCarouselProps.objectFit, videosMuted = mediaCarouselProps.videosMuted, background = mediaCarouselProps.background, playlistId = mediaCarouselProps.playlistId, defaultInterval = mediaCarouselProps.defaultInterval;
    var _b = (0, react_1.useState)(undefined), displayIndex = _b[0], setDisplayIndex = _b[1];
    var _c = (0, react_1.useState)((0, nanoid_1.nanoid)()), playKey = _c[0], setPlayKey = _c[1];
    var playNext = function () {
        setPlayKey((0, nanoid_1.nanoid)());
    };
    var handleVideoOnEnded = function () {
        playNext();
    };
    (0, react_1.useEffect)(function () {
        // make sure that playback starts from the first index when carouselItems changes
        setDisplayIndex(0);
    }, [carouselItems]);
    (0, react_1.useEffect)(function () {
        var timer;
        if (carouselItems.length > 0) {
            var nextDisplayIndex = getNextVisiblePlaylistItemIndex(carouselItems, displayIndex);
            setDisplayIndex(nextDisplayIndex);
            if (typeof nextDisplayIndex === 'number') {
                var currentItem_1 = carouselItems[nextDisplayIndex];
                // delay if image. Video has onEnded event
                if (currentItem_1 &&
                    ((0, seesignage_utils_1.isImagePlaylistItemPlayer)(currentItem_1) || (0, seesignage_utils_1.isContentPlaylistItemPlayer)(currentItem_1))) {
                    var interval = typeof currentItem_1.interval === 'number'
                        ? currentItem_1.interval * 1000
                        : defaultInterval * 1000;
                    timer = setTimeout(function () {
                        playNext();
                    }, interval);
                }
            }
            else if (typeof nextDisplayIndex === 'undefined') {
                // eslint-disable-next-line no-console
                console.log("Media carousel: no visible item found by conditions from ".concat(playlistId, " playlist. Try again in 10 seconds."));
                timer = setTimeout(function () {
                    playNext();
                }, 10000);
            }
        }
        return function () {
            if (timer) {
                clearTimeout(timer);
            }
        };
    }, [playKey, carouselItems]);
    // show message only when widget is in edit mode. (content editor view)
    if (carouselItems.length === 0 && editable) {
        return (react_1.default.createElement(MediaCarouselMediaMissing_1.default, null,
            react_1.default.createElement("p", null, "The playlist has no visible items or it has been deleted.")));
    }
    var currentItem = typeof displayIndex === 'number' ? carouselItems[displayIndex] : undefined;
    if ((0, seesignage_utils_1.isImagePlaylistItemPlayer)(currentItem)) {
        return (react_1.default.createElement(MediaCarouselImage_1.default, { objectFit: objectFit, src: currentItem.url, background: background }));
    }
    if ((0, seesignage_utils_1.isVideoPlaylistItemPlayer)(currentItem)) {
        return (react_1.default.createElement(MediaCarouselVideo_1.default, { objectFit: objectFit, src: currentItem.url, muted: videosMuted ? true : false, autoPlay: true, loop: carouselItems.length === 1, onEnded: handleVideoOnEnded, background: background }));
    }
    if ((0, seesignage_utils_1.isContentPlaylistItemPlayer)(currentItem)) {
        return (react_1.default.createElement(MediaCarouselContent_1.default, { content: currentItem.content, viewWidth: width, viewHeight: height, objectFit: objectFit, background: background }));
    }
    return react_1.default.createElement(react_1.Fragment, null);
};
exports.default = MediaCarouselComponent;
//# sourceMappingURL=MediaCarouselPlaylistComponent.js.map